import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchDescriptionMantainStockAdjusment = (parameter = 'TODOS') => {
  return apiActionCreator({
    'endpoint': `/parts/stock-adjustment/description?code=${parameter}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_DESCRIPTION_MANTAIN_SA_LIST,
      ActionTypes.FETCHED_DESCRIPTION_MANTAIN_SA_LIST,
      [
        ActionTypes.FETCHED_DESCRIPTION_MANTAIN_SA_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const addDescriptionMantainStockAdjusment = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/parts/stock-adjustment/description',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_DESCRIPTION_MANTAIN_SA_LIST,
        [
          () => {
            dispatch(fetchDescriptionMantainStockAdjusment());
            return {
              'type': ActionTypes.ADDED_DESCRIPTION_MANTAIN_SA_LIST,
            };
          },
          () => MessageActions.addMessageBoxInfo('Registro Creado'),
        ],
        [ActionTypes.ADDED_DESCRIPTION_MANTAIN_SA_LIST_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const updateDescriptionMantainStockAdjusment = (data = {}, id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/parts/stock-adjustment/description/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_DESCRIPTION_MANTAIN_SA_LIST,
        [
          () => {
            dispatch(fetchDescriptionMantainStockAdjusment());
            return {
              'type': ActionTypes.UPDATED_DESCRIPTION_MANTAIN_SA_LIST,
            };
          },
          () => MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.UPDATED_DESCRIPTION_MANTAIN_SA_LIST_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};

export const daleteDescriptionMantainStockAdjusment = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/parts/stock-adjustment/description/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.REMOVING_DESCRIPTION_MANTAIN_SA_LIST,
        [
          () => {
            dispatch(fetchDescriptionMantainStockAdjusment());
            return {
              'type': ActionTypes.REMOVED_DESCRIPTION_MANTAIN_SA_LIST,
            };
          },
          () => MessageActions.addMessageBoxInfo('Registro Eliminado'),
        ],
        [ActionTypes.REMOVED_DESCRIPTION_MANTAIN_SA_LIST_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'DELETE',
    })
  );
};
